import {
  FaHome,
  FaUser,
  FaBook,
  FaCog,
  FaVolumeMute,
  FaVolumeUp,
  FaChartBar,
  FaSchool,
  FaRegAddressCard,
  FaFolder,
} from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import "./BlueSidebar.css";
import "./Sidebar.css";
import { Context2 } from "./Audio";
import PilotButton from "./PilotButton";
import { isDemoUser } from "@/utils/userFlags";
import { useAuth } from "../features/auth";
import PracticeSettingsOverlay from "@/screens/HomeScreen/practice-settings/PracticeSettingsOverlay";
import {
  PRACTICE_SETTINGS_DISABLED_PATHS,
  PRACTICE_SETTINGS_PATHS,
} from "@/screens/HomeScreen/practice-settings/config";

const SettingsMenuItem = ({
  rowClass,
  iconClass,
  isPracticeSettingsAvailable,
  isPracticeSettingsDisabled,
  isPracticeSettingsOpen,
  openPracticeSettings,
  isOptionsScreenActive,
  currentPath,
}) => {
  const content = (
    <>
      <div className={rowClass}>
        <div className={iconClass}>
          <FaCog></FaCog>
        </div>
        <h1 className="icontext">Settings</h1>
      </div>
      <p className="linklabel">
        {isPracticeSettingsAvailable
          ? "Change practice settings"
          : isPracticeSettingsDisabled
            ? "Unavailable during this step"
            : "Manage your profile"}
      </p>
    </>
  );

  if (isPracticeSettingsAvailable) {
    return (
      <Link
        to={currentPath}
        className={isPracticeSettingsOpen ? "active" : ""}
        onClick={(event) => {
          event.preventDefault();
          openPracticeSettings();
        }}
      >
        {content}
      </Link>
    );
  }

  if (isPracticeSettingsDisabled) {
    return (
      <Link
        to={currentPath}
        className="cursor-not-allowed opacity-50"
        aria-disabled="true"
        onClick={(event) => {
          event.preventDefault();
        }}
      >
        {content}
      </Link>
    );
  }

  return (
    <Link to="/optionsscreen" className={isOptionsScreenActive ? "active" : ""}>
      {content}
    </Link>
  );
};

const BlueSidebar = () => {
  const { user } = useAuth();
  const [playing, setPlaying] = useContext(Context2);
  const navigate = useNavigate();
  const location = useLocation();
  const isDemo = isDemoUser(user);
  const [isPracticeSettingsOpen, setIsPracticeSettingsOpen] = useState(false);
  const isPracticeSettingsAvailable = PRACTICE_SETTINGS_PATHS.has(
    location.pathname,
  );
  const isPracticeSettingsDisabled = PRACTICE_SETTINGS_DISABLED_PATHS.has(
    location.pathname,
  );

  useEffect(() => {
    setIsPracticeSettingsOpen(false);
  }, [location.pathname]);

  const openPracticeSettings = () => {
    setIsPracticeSettingsOpen(true);
  };

  const closePracticeSettings = () => {
    setIsPracticeSettingsOpen(false);
  };

  async function changeAudio(audio) {
    document.cookie = `audio=${audio}; path=/; SameSite=Strict; Secure`;
    if (location.pathname === "/deepbreathe") {
      navigate("/deepbreathecopy");
    } else {
      navigate(location.pathname);
    }
    setPlaying(audio);
  }
  const [isActive, setIsActive] = useState(false);
  const toggleSidebar = () => {
    setIsActive(!isActive);
  };

  return (
    <>
      <div className={`ham ${isActive ? "active" : ""}`}>
        <div>
          <img
            className="subtab-logo"
            src="images/123WellnessLogo green-02.png"
            alt="1-2-3 Wellness"
            loading="lazy"
          />
        </div>
        <div
          className={`ham-menu ${isActive ? "active" : ""}`}
          onClick={toggleSidebar}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className="sidebar">
        <div
          className={`sidebarcolumn ${isActive ? "active" : ""}`}
          onClick={toggleSidebar}
        >
          <div className="sidebarrow">
            <Link to="/">
              <img
                className="sidebarlogo"
                src="../images/123WellnessLogo green-02.png"
                alt="1-2-3 Wellness"
                loading="lazy"
              />
            </Link>
            {user?.role === "student" && (
              <div className="alignMenuOptions">
                <Link
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  <div className="icontextrowstudent">
                    <div className="styleiconstudenthome">
                      <FaHome></FaHome>
                    </div>
                    <h1 className="icontexthome">Home</h1>
                  </div>
                  <p className="linklabel">Start practicing wellness</p>
                </Link>
                <Link
                  to="/studentdashboard"
                  className={
                    location.pathname === "/studentdashboard" ? "active" : ""
                  }
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaUser></FaUser>
                    </div>
                    <h1 className="icontext">My Story</h1>
                  </div>
                  <p className="linklabel">Learn about YOUR wellness</p>
                </Link>
                {playing === true ? (
                  <div className="menuaction">
                    <div
                      className="icontextrowstudent"
                      onClick={() => changeAudio(false)}
                    >
                      <div className="styleiconstudent">
                        <FaVolumeUp></FaVolumeUp>
                      </div>
                      <h1 className="icontext"> Volume </h1>
                    </div>
                    <p className="linklabel">Turn sound on/off</p>
                  </div>
                ) : (
                  <div className="menuaction">
                    <div
                      className="icontextrowstudent"
                      onClick={() => changeAudio(true)}
                    >
                      <div className="styleiconstudent">
                        <FaVolumeMute></FaVolumeMute>
                      </div>
                      <h1 className="icontext"> Volume </h1>
                    </div>
                    <p className="linklabel">Turn sound on/off</p>
                  </div>
                )}
                {!isDemo && (
                  <Link
                    to="/resourcestab"
                    className={
                      location.pathname === "/resourcestab" ? "active" : ""
                    }
                  >
                    <div className="icontextrowadmin">
                      <div className="styleiconadmin">
                        <FaFolder></FaFolder>
                      </div>
                      <h1 className="icontext">Resources</h1>
                    </div>
                    <p className="linklabel">
                      Access powerful tools and videos
                    </p>
                  </Link>
                )}
                <SettingsMenuItem
                  rowClass="icontextrowstudent"
                  iconClass="styleiconstudent"
                  isPracticeSettingsAvailable={isPracticeSettingsAvailable}
                  isPracticeSettingsDisabled={isPracticeSettingsDisabled}
                  isPracticeSettingsOpen={isPracticeSettingsOpen}
                  openPracticeSettings={openPracticeSettings}
                  isOptionsScreenActive={location.pathname === "/optionsscreen"}
                  currentPath={location.pathname}
                />
              </div>
            )}
            {user?.role === "teacher" && (
              <div className="alignMenuOptions">
                <Link
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  <div className="icontextrowteacher">
                    <div className="styleiconteacherhome">
                      <FaHome></FaHome>
                    </div>
                    <h1 className="icontexthome">Home</h1>
                  </div>
                  <p className="linklabel">Start practicing wellness</p>
                </Link>
                <Link
                  to="/studentdashboard"
                  className={
                    location.pathname === "/studentdashboard" ? "active" : ""
                  }
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaUser></FaUser>
                    </div>
                    <h1 className="icontext">My Story</h1>
                  </div>
                  <p className="linklabel">Learn about YOUR wellness</p>
                </Link>
                <Link
                  to="/dashboard"
                  className={location.pathname === "/dashboard" ? "active" : ""}
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaChartBar></FaChartBar>
                    </div>
                    <h1 className="icontext">Educator Dashboard</h1>
                  </div>
                  <p className="linklabel">
                    Learn about your STUDENT'S wellness
                  </p>
                </Link>
                <Link
                  to="/studentsupports"
                  className={
                    location.pathname === "/studentsupports" ? "active" : ""
                  }
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaRegAddressCard />
                    </div>
                    <h1 className="icontext">Student Supports</h1>
                  </div>
                  <p className="linklabel">
                    Learn WHO may need MORE SUPPORT (tier 2 & 3 MTSS)
                  </p>
                </Link>
                {playing === true ? (
                  <div className="menuaction">
                    <div
                      className="icontextrowteacher"
                      onClick={() => changeAudio(false)}
                    >
                      <div className="styleiconteacher">
                        <FaVolumeUp></FaVolumeUp>
                      </div>
                      <h1 className="icontext"> Volume </h1>
                    </div>
                    <p className="linklabel">Turn sound on/off</p>
                  </div>
                ) : (
                  <div className="menuaction">
                    <div
                      className="icontextrowteacher"
                      onClick={() => changeAudio(true)}
                    >
                      <div className="styleiconteacher">
                        <FaVolumeMute></FaVolumeMute>
                      </div>
                      <h1 className="icontext"> Volume </h1>
                    </div>
                    <p className="linklabel">Turn sound on/off</p>
                  </div>
                )}
                {!isDemo && (
                  <Link
                    to="/resourcestab"
                    className={
                      location.pathname === "/resourcestab" ? "active" : ""
                    }
                  >
                    <div className="icontextrowadmin">
                      <div className="styleiconadmin">
                        <FaFolder></FaFolder>
                      </div>
                      <h1 className="icontext">Resources</h1>
                    </div>
                    <p className="linklabel">
                      Access powerful tools and videos
                    </p>
                  </Link>
                )}
                <SettingsMenuItem
                  rowClass="icontextrowteacher"
                  iconClass="styleiconteacher"
                  isPracticeSettingsAvailable={isPracticeSettingsAvailable}
                  isPracticeSettingsDisabled={isPracticeSettingsDisabled}
                  isPracticeSettingsOpen={isPracticeSettingsOpen}
                  openPracticeSettings={openPracticeSettings}
                  isOptionsScreenActive={location.pathname === "/optionsscreen"}
                  currentPath={location.pathname}
                />
              </div>
            )}
            {user?.role === "admin" && (
              <div className="alignMenuOptions">
                <Link
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadminhome">
                      <FaHome></FaHome>
                    </div>
                    <h1 className="icontexthome">Home</h1>
                  </div>
                  <p className="linklabel">Start practicing wellness</p>
                </Link>
                <Link
                  to="/studentdashboard"
                  className={
                    location.pathname === "/studentdashboard" ? "active" : ""
                  }
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaUser></FaUser>
                    </div>
                    <h1 className="icontext">My Story</h1>
                  </div>
                  <p className="linklabel">Learn about YOUR wellness</p>
                </Link>
                <Link
                  to="/dashboard"
                  className={location.pathname === "/dashboard" ? "active" : ""}
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaChartBar></FaChartBar>
                    </div>
                    <h1 className="icontext">Educator Dashboard</h1>
                  </div>
                  <p className="linklabel">
                    Learn about your STUDENT'S wellness
                  </p>
                </Link>
                <Link
                  to="/studentsupports"
                  className={
                    location.pathname === "/studentsupports" ? "active" : ""
                  }
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaRegAddressCard />
                    </div>
                    <h1 className="icontext">Student Supports</h1>
                  </div>
                  <p className="linklabel">
                    Learn WHO may need MORE SUPPORT (tier 2 & 3 MTSS)
                  </p>
                </Link>
                
                {playing === true ? (
                  <div className="menuaction">
                    <div
                      className="icontextrowadmin"
                      onClick={() => changeAudio(false)}
                    >
                      <div className="styleiconadmin">
                        <FaVolumeUp></FaVolumeUp>
                      </div>
                      <h1 className="icontext"> Volume </h1>
                    </div>
                    <p className="linklabel">Turn sound on/off</p>
                  </div>
                ) : (
                  <div className="menuaction">
                    <div
                      className="icontextrowadmin"
                      onClick={() => changeAudio(true)}
                    >
                      <div className="styleiconadmin">
                        <FaVolumeMute></FaVolumeMute>
                      </div>
                      <h1 className="icontext"> Volume </h1>
                    </div>
                    <p className="linklabel">Turn sound on/off</p>
                  </div>
                )}
                {!isDemo && (
                  <Link
                    to="/resourcestab"
                    className={
                      location.pathname === "/resourcestab" ? "active" : ""
                    }
                  >
                    <div className="icontextrowadmin">
                      <div className="styleiconadmin">
                        <FaFolder></FaFolder>
                      </div>
                      <h1 className="icontext">Resources</h1>
                    </div>
                    <p className="linklabel">
                      Access powerful tools and videos
                    </p>
                  </Link>
                )}
                <SettingsMenuItem
                  rowClass="icontextrowadmin"
                  iconClass="styleiconadmin"
                  isPracticeSettingsAvailable={isPracticeSettingsAvailable}
                  isPracticeSettingsDisabled={isPracticeSettingsDisabled}
                  isPracticeSettingsOpen={isPracticeSettingsOpen}
                  openPracticeSettings={openPracticeSettings}
                  isOptionsScreenActive={location.pathname === "/optionsscreen"}
                  currentPath={location.pathname}
                />
              </div>
            )}
            {user?.role === "superadmin" && (
              <div className="alignMenuOptions">
                <Link
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadminhome">
                      <FaHome></FaHome>
                    </div>
                    <h1 className="icontexthome">Home</h1>
                  </div>
                  <p className="linklabel">Start practicing wellness</p>
                </Link>
                <Link
                  to="/studentdashboard"
                  className={
                    location.pathname === "/studentdashboard" ? "active" : ""
                  }
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaUser></FaUser>
                    </div>
                    <h1 className="icontext">My Story</h1>
                  </div>
                  <p className="linklabel">Learn about YOUR wellness</p>
                </Link>
                <Link
                  to="/dashboard"
                  className={location.pathname === "/dashboard" ? "active" : ""}
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaChartBar></FaChartBar>
                    </div>
                    <h1 className="icontext">Educator Dashboard</h1>
                  </div>
                  <p className="linklabel">
                    Learn about your STUDENT'S wellness
                  </p>
                </Link>
                <Link
                  to="/studentsupports"
                  className={
                    location.pathname === "/studentsupports" ? "active" : ""
                  }
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaRegAddressCard />
                    </div>
                    <h1 className="icontext">Student Supports</h1>
                  </div>
                  <p className="linklabel">
                    Learn WHO may need MORE SUPPORT (tier 2 & 3 MTSS)
                  </p>
                </Link>
                
                {playing === true ? (
                  <div className="menuaction">
                    <div
                      className="icontextrowadmin"
                      onClick={() => changeAudio(false)}
                    >
                      <div className="styleiconadmin">
                        <FaVolumeUp></FaVolumeUp>
                      </div>
                      <h1 className="icontext"> Volume </h1>
                    </div>
                    <p className="linklabel">Turn sound on/off</p>
                  </div>
                ) : (
                  <div className="menuaction">
                    <div
                      className="icontextrowadmin"
                      onClick={() => changeAudio(true)}
                    >
                      <div className="styleiconadmin">
                        <FaVolumeMute></FaVolumeMute>
                      </div>
                      <h1 className="icontext"> Volume </h1>
                    </div>
                    <p className="linklabel">Turn sound on/off</p>
                  </div>
                )}
                {!isDemo && (
                  <Link
                    to="/resourcestab"
                    className={
                      location.pathname === "/resourcestab" ? "active" : ""
                    }
                  >
                    <div className="icontextrowadmin">
                      <div className="styleiconadmin">
                        <FaFolder></FaFolder>
                      </div>
                      <h1 className="icontext">Resources</h1>
                    </div>
                    <p className="linklabel">
                      Access powerful tools and videos
                    </p>
                  </Link>
                )}
                <SettingsMenuItem
                  rowClass="icontextrowadmin"
                  iconClass="styleiconadmin"
                  isPracticeSettingsAvailable={isPracticeSettingsAvailable}
                  isPracticeSettingsDisabled={isPracticeSettingsDisabled}
                  isPracticeSettingsOpen={isPracticeSettingsOpen}
                  openPracticeSettings={openPracticeSettings}
                  isOptionsScreenActive={location.pathname === "/optionsscreen"}
                  currentPath={location.pathname}
                />
              </div>
            )}

            {user?.role === "123wellness" && (
              <div className="alignMenuOptions">
                <Link
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadminhome">
                      <FaHome></FaHome>
                    </div>
                    <h1 className="icontexthome">Home</h1>
                  </div>
                  <p className="linklabel">Start practicing wellness</p>
                </Link>
                <Link
                  to="/studentdashboard"
                  className={
                    location.pathname === "/studentdashboard" ? "active" : ""
                  }
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaUser></FaUser>
                    </div>
                    <h1 className="icontext">My Story</h1>
                  </div>
                  <p className="linklabel">Learn about YOUR wellness</p>
                </Link>
                <Link
                  to="/dashboard"
                  className={location.pathname === "/dashboard" ? "active" : ""}
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaChartBar></FaChartBar>
                    </div>
                    <h1 className="icontext">Educator Dashboard</h1>
                  </div>
                  <p className="linklabel">Learn about a STUDENT'S wellness</p>
                </Link>
                <Link
                  to="/studentsupports"
                  className={
                    location.pathname === "/studentsupports" ? "active" : ""
                  }
                >
                  <div className="icontextrowadmin">
                    <div className="styleiconadmin">
                      <FaRegAddressCard />
                    </div>
                    <h1 className="icontext">Student Supports</h1>
                  </div>
                  <p className="linklabel">
                    Learn WHO may need MORE SUPPORT (tier 2 & 3 MTSS)
                  </p>
                </Link>

                {playing === true ? (
                  <div className="menuaction">
                    <div
                      className="icontextrowadmin"
                      onClick={() => changeAudio(false)}
                    >
                      <div className="styleiconadmin">
                        <FaVolumeUp></FaVolumeUp>
                      </div>
                      <h1 className="icontext"> Volume </h1>
                    </div>
                    <p className="linklabel">Turn sound on/off</p>
                  </div>
                ) : (
                  <div className="menuaction">
                    <div
                      className="icontextrowadmin"
                      onClick={() => changeAudio(true)}
                    >
                      <div className="styleiconadmin">
                        <FaVolumeMute></FaVolumeMute>
                      </div>
                      <h1 className="icontext"> Volume </h1>
                    </div>
                    <p className="linklabel">Turn sound on/off</p>
                  </div>
                )}
                {!isDemo && (
                  <Link
                    to="/resourcestab"
                    className={
                      location.pathname === "/resourcestab" ? "active" : ""
                    }
                  >
                    <div className="icontextrowadmin">
                      <div className="styleiconadmin">
                        <FaFolder></FaFolder>
                      </div>
                      <h1 className="icontext">Resources</h1>
                    </div>
                    <p className="linklabel">
                      Access powerful tools and videos
                    </p>
                  </Link>
                )}
                <SettingsMenuItem
                  rowClass="icontextrowadmin"
                  iconClass="styleiconadmin"
                  isPracticeSettingsAvailable={isPracticeSettingsAvailable}
                  isPracticeSettingsDisabled={isPracticeSettingsDisabled}
                  isPracticeSettingsOpen={isPracticeSettingsOpen}
                  openPracticeSettings={openPracticeSettings}
                  isOptionsScreenActive={location.pathname === "/optionsscreen"}
                  currentPath={location.pathname}
                />
              </div>
            )}
          </div>
          <PilotButton variant="sidebar" />

          <div className="growthwell">
            <p>© Growthwell LLC 2026</p>
            <p>U.S. Patent No. 12,053,300</p>
          </div>
        </div>
      </div>
      <PracticeSettingsOverlay
        isOpen={isPracticeSettingsOpen}
        onClose={closePracticeSettings}
      />
    </>
  );
};
export default BlueSidebar;
